<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5" > <!--v-if="!hasPatientRole && !hasSouscripteurRole"!-->

            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">
            <b-row >
                <b-col col sm="12">
                    <div class="card shadow">
                        <div class="card-body p-0">
                            <h3 class="text-center">{{$t('message.searchPatient')}}</h3>
                            <section class="container p-0" id="appointment-table">
                                <div class="appointment-table-header my-2 mb-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-input-group
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        class="p-2"
                                                        :placeholder="$t('message.search') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="ml-1">
                                                <div class="d-flex">
                                                   
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="sortSelected"
                                                            size="sm"
                                                            :options="sortOptions"></b-form-select>
                                                    <div class="">
                                         

                                                     </div>
                                                    <div>
                                                        <b-button-group size="sm" class="mr-1">
                                                            <b-button
                                                                    :disabled="sortDirection === 'asc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='asc'"
                                                            >
                                                                <i class="fa fa-sort-amount-up-alt"></i>
                                                            </b-button>
                                                            <b-button
                                                                    :disabled="sortDirection === 'desc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='desc'"
                                                            >
                                                                <i class="fa fa-sort-amount-down-alt"></i>
                                                            </b-button>
                                                            <b-form-select class="d-inline-block mr-2" v-model="responsable" size="sm" :options="mDoctors"></b-form-select>
                                                        </b-button-group>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 overflow-auto">
                                            <div class="ml-1">
                                                <div
                                                        v-if="paginationObject!==null && paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row appointment-table-content">
                                <div class="container-fluid">
                                    <template v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0">
                                        <div v-for="(patient, key) in paginationObject.display(paginationObject.currentPageNumber)" :key="key" class="row appointment-item hovered" @click="onPatientPerInstCellClick({row: patient})">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $tc('message.patients', 1) }}
                                                        </span>
                                                        <h4 class="appointment-date">{{ patient.nom }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.fileNumber') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.dossier }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.old') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.age }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.email') }}
                                                        </span>
                                                        <h4 class="appointment-hour">
                                                            {{ patient.email }}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div class="row" style="padding-bottom:-20px">

                                                    <div class="col-lg-3 success">
                                                        <span class="appointment-label">
                                                            {{ $tc('message.doctorName', 1) }}
                                                        </span>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.phoneNumber') }}
                                                        </span>
                                                    </div>
                                                    <div class="col-lg-3">

                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.email') }}
                                                        </span>
                                                    </div>

                                                </div>
                                                <div class="row pt-0" v-for="item in patient.doctors" :key="item.id">
                                                    <hr />
                                                    <div class="col-lg-3 success">
                                                        <h4 class="appointment-date">{{ item.nom }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <h4 class="appointment-hour">
                                                            {{ item.phone }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">

                                                    </div>
                                                    <div class="col-lg-3">
                                                        <h4 class="appointment-hour">
                                                            {{ item.email }}
                                                        </h4>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </template>

                                    <template v-else>
                                        <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                    </template>

                                </div>
                            </div>
                            </section>
                        </div>
                    </div>
                    <!--<b-card no-body>
                        <b-tabs
                                card
                                content-class="mt-3"
                                fill
                                active-nav-item-class="font-weight-bold text-uppercase text-success"
                        >
                            &lt;!&ndash;                            <b-tab no-body :title="$t('message.previousOperations')" v-if="notEmpty(operationsRows)">&ndash;&gt;
                            &lt;!&ndash;                                <b-card-body>&ndash;&gt;
                            &lt;!&ndash;                                    <vue-good-table&ndash;&gt;
                            &lt;!&ndash;                                            id="operation"&ndash;&gt;
                            &lt;!&ndash;                                            v-if="notEmpty(operationsRows)"&ndash;&gt;
                            &lt;!&ndash;                                            :columns="operationsColumns"&ndash;&gt;
                            &lt;!&ndash;                                            :rows="operationsRows"&ndash;&gt;
                            &lt;!&ndash;                                            :search-options="enabled"&ndash;&gt;
                            &lt;!&ndash;                                            :pagination-options="paginationOptions"&ndash;&gt;
                            &lt;!&ndash;                                            @on-row-click="onOperationClick"&ndash;&gt;
                            &lt;!&ndash;                                    />&ndash;&gt;
                            &lt;!&ndash;                                </b-card-body>&ndash;&gt;
                            &lt;!&ndash;                            </b-tab>&ndash;&gt;
                            <b-tab no-body :title="$t('message.searchPatient')" v-if="notEmpty(patientPeInstitutionsRows)">
                                <b-card-body>
                                    <div class="vgt-global-search vgt-clearfix">
                                        <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                            <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                        </div>
                                        <div class="vgt-global-search__actions vgt-pull-right">

                                        </div>
                                    </div>
                                    <vue-good-table
                                            id="patientPerInstitution"
                                            v-if="notEmpty(patientPeInstitutionsRows)"
                                            :columns="patientPeInstitutionsColumns"
                                            :rows="patientPeInstitutionsRowsFilter"
                                            :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                            :pagination-options="paginationOptions"

                                            @on-cell-click="onPatientPerInstCellClick"
                                    />
                                </b-card-body>
                            </b-tab>

                        </b-tabs>
                    </b-card>-->
                </b-col>
            </b-row>

            <!--            <b-container>-->
            <!--                <h3 class="text-center">{{ $t('message.select') }} {{ $tc('message.institutions',1) }}</h3>-->
            <!--                <vue-good-table-->
            <!--                        class="mt-4"-->
            <!--                        id="etablissements2"-->
            <!--                        v-if="notEmpty(mInstitutions)"-->
            <!--                        :columns="etablissementsColumns"-->
            <!--                        :rows="mInstitutions"-->
            <!--                        :search-options="enabled"-->
            <!--                        :pagination-options="paginationOptions"-->
            <!--                        @on-row-click="onEtablissementClick"-->
            <!--                />-->
            <!--            </b-container>-->
        </b-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { ModelSelect } from 'vue-search-select';
    import Swal from 'sweetalert2';
	import {pagination, handlePaginationClick, paginationDataProperty} from "../../helpers/paginations";
    import loading from 'vue-loading-overlay';
    export default {
        name: "PractionerDashboard",

        computed: {
            ...mapGetters(["patients",
                "selectedInstitution",
                "userInstitutions",
                "institutions",
                'hasAdminRole',
                "controlDoctors",
                'hasGestionnaireRole',
                'hasMedecinControleRole',
                'hasPatientRole',
                'hasSouscripteurRole',
                "operations",
                'hasAssistante'
            ]),
            // mafunction(){
            //     console.log("ici mm");
            //     console.log(this.paginationObject);
            // }
            

            
        },

        components: {
            ModelSelect
        },
        watch: {
            item(newValue, lastValue){
                // console.log("on est ici 1");
                if (newValue.value != '0'){
                    this.onEtablissementClick(newValue.value);
                }
                else{
                    this.$store.dispatch('setselectedInstitution', { selectedInstitution : {} });
                }
            },

            filteredValue(sArray,value){
             
             this.typeFilter(this.currentPatientArrayFiltered);
            },

            searchTerm:function (newValue, oldValue) {
                
                if (newValue.trim().length ==0){
                    this.patientPeInstitutionsRowsFilter = [];
                }else{
                    this.patientPeInstitutionsRowsFilter = this.mPatients;
                }

            },

			institutions: function (newValue, oldValue) {
                // console.log("on a les institutions?");
                // console.log(this.shouldDisplay);
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

			currentPatientArray: function (newValue, oldValue) {
                // console.log("on est ici");
                // console.log(newValue);
				this.paginationObject = pagination(newValue);
                // console.log(this.paginationObject);
			},

			filterCriteria: async function (newValue, oldValue) {
                // console.log("on est ici maintenant?");
                // console.log(newValue);
                
				if (newValue.length >= 3) {
                    this.loading=true;
                    await this.getSearchPatient(newValue)
                    this.loading=false;
                        //console.log(this.patients);
                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
                    this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
                    
					this.handleFilter(newValue);
                    
                    
				}
                if (newValue.length > 15) {
                    // await this.getSearchPatient(newValue)
                    //     console.log(this.patients);
                    if(!this.shouldDisplay)
					    this.shouldDisplay = true;
                    
                    // this.currentPatientArray = this.mPatients();
					// this.currentPatientArrayFiltered = this.currentPatientArray;
                    
					this.handleFilter(newValue);
                    
                    
				}
			},

			sortDirection: function (newValue, oldValue) {
				this.handleSort(this.sortSelected ,newValue);
			},

			sortSelected: function (newValue, oldValue) {
				this.handleSort(newValue, this.sortDirection);
			},

			shouldDisplay: function (newValue, oldValue) {
                // console.log("Ensuite on est ici maintenant?");
                console.log(newValue);
				if (newValue) {
                    // console.log("Ensuite on est ici nor?");
                    // console.log("Ensuite on est ici nor?");
                    // if(this.institutions==null)
					this.currentPatientArray = this.mPatients();
					this.currentPatientArrayFiltered = this.currentPatientArray;
				} else {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				}
			}
        },
        data() {
            return {
                
				...paginationDataProperty(this.$i18n),
                filtered:[
                    {value:1,text:'Tous'},
                    {value:2,text:'Non Archivés'},
                    {value:3,text:'Non Transmis'},
                    {value:4,text:'Archivés'},
                    {value:5,text:'Transmis'},
                ],
                filteredValue:null,
				shouldDisplay: false,
                loading:false,
                patientPeInstitutionsRowsFilter: [],

                searchTerm : '',

                item: {
                    value: '',
                    text: ''
                },

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                operationsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'element',
                        label: this.$i18n.tc('message.operations', 1)
                    },
                    {
                        field: 'action',
                        label: this.$i18n.t('message.action')
                    },
                ],

                patientPeInstitutionsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'dossier',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'age',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                ],

                etablissementsColumns: [
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'nom',
                    },
                    {

                        label: this.$i18n.t('message.description'),
                        field: 'description'
                    },
                ],
            }
        },

        methods:{
            // async mPatients1(value) {
            //     console.log("on entre ici?");
            //     await this.getSearchPatient(value);
            //     console.log(this.patients);
            //         return this.patients;
            // },

            mPatients() {
            let pArray = [];
            // _.forEach(this.institutions, function (institution) {
                _.forEach(this.patients, function (patient) {
                    let p = {};

                    if (typeof patient.user == 'object' && !_.isNull(patient.user)) {

                        let prenom = patient.user.prenom ? patient.user.prenom : '';
                        prenom = prenom.toLowerCase();
                        p.nom = (patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        p.dossier = patient.dossier.numero_dossier
                        p.email = patient.user.email;
                        p.telephone = patient.user.telephone;
                        p.age = moment().year() - moment(patient.date_de_naissance).year();
                        p.sexe = patient.sexe;
                        p.nationalite = patient.user.nationalite;
                        p.ville = patient.user.ville;
                        p.pays = patient.user.pays;
                        p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                        p.id = patient.user.id;
                        p.slug = patient.user.slug;
                        p.adresse = patient.user.adresse;
                        p.fileSlug = patient.dossier.slug;
                        // p.institutionId = institution.id;
                        if(!_.isUndefined(patient.etablissements[0]))
                            p.institutionId = patient.etablissements[0].id;
                    }
                    p.doctors = [];
                    if (!_.isUndefined(patient.medecin_referent) && patient.medecin_referent.length > 0) {

                        _.forEach(patient.medecin_referent, function (doctor) {
                            let d = {};
                            if ((typeof doctor.medecin_controles.user == 'object') && (!_.isNull(doctor.medecin_controles.user))) {
                                let prenom = doctor.medecin_controles.user.prenom != null ? doctor.medecin_controles.user.prenom : "";
                                prenom = prenom.toLowerCase();
                                d.nom = (doctor.medecin_controles.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                d.id = doctor.medecin_controles.user.id;
                                d.phone = doctor.medecin_controles.user.telephone
                                d.email = doctor.medecin_controles.user.email
                                if (d.nom.length > 0) {
                                    p.doctors.push(d);
                                }
                            }

                        });
                        // console.log(p.doctors);

                    }

                    let hasPatient = _.filter(pArray, function (item) {
                        if (item.dossier == p.dossier)
                            return p;
                    })
                    if (_.isEmpty(hasPatient)) {
                        pArray.push(p);
                    }
                });
                // console.log("pArray");
                // console.log(pArray);
            // });
            return pArray;
        },

            mInstitutions: function() {
                let iArray = [];
                let self = this;
                // let self = this;
                _.forEach(this.institutions, function(institution) {
                    // if(typeof institution.patients == "object"){
                    //     _.forEach(institution.patients, function(patient) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    // i.id = institution.id + patient.user_id;
                    i.slug = institution.slug;
                    // i.pnom = self.formatString((patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase() ) + " ( "
                    //     +patient.dossier.numero_dossier + " )";
                    // i.pslug = patient.slug;

                    iArray.push(i);
                });
                // }

                // });

                return iArray;
            },
            mUserInstitutions: function() {
                let iArray = [];
                // let self = this;
                _.forEach(this.userInstitutions, function(institution) {
                    // if(typeof institution.patients == "object"){
                    //     _.forEach(institution.patients, function(patient) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = institution.description;
                    i.etablissementId = institution.id;
                    i.id = institution.id;
                    i.slug = institution.slug;
                    i.patients = institution.patients;
                    // i.pnom = self.formatString((patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase() ) + " ( "
                    //     +patient.dossier.numero_dossier + " )";
                    // i.pslug = patient.slug;
                    iArray.push(i);
                });
                // }

                // });
                return iArray;
            },
            mDoctors: function () {
            let dArray = [{ value: null, text:"Medecin de suivi", disabled: true }];

            _.forEach(_.orderBy(this.controlDoctors, ['created_at'], ['desc']), function (doctor) {
                let d = {};
                if ((typeof doctor.user == 'object') && (!_.isNull(doctor.user))) {
                    let prenom = doctor.user.prenom != null ? doctor.user.prenom : "";
                    prenom = prenom.toLowerCase();
                    d.text = (doctor.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    d.value = doctor.user.id;

                    if (d.text.length > 0) {
                        dArray.push(d);
                    }
                }

            });
            // console.log(dArray)
            return dArray;
        },

            options:function(){
                let oArray = [];

                _.forEach(this.mInstitutions, function (institution) {
                    oArray.push({value:institution.etablissementId, text:  institution.nom});
                })  ;
                oArray.push({value:'0',text:'All'});
                return oArray;
            },

            operationsRows:function(){
                let oArray = [];
                let self = this;
                //Ici on va filtrer pour ne laisser que les patients qui sont dans l'etablissement selectionné
                let selectedOperations = [];

                _.forEach(this.operations,function (operation) {
                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')) {
                            // if (!_.isEmpty(self.selectedInstitution)) {
                            //     let selectedPatients = self.selectedInstitution[0].patients;
                            //     _.forEach(selectedPatients, function (patient) {
                            //         if (!_.isNull(patient.dossier)) {
                            //             if (patient.dossier.numero_dossier == operation.dossier.numero_dossier){
                            selectedOperations.push(operation);
                            //             }
                            //         }
                            //     })
                            // }
                        }
                    }
                });

                _.forEach(selectedOperations, function(operation) {

                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')){
                            let user = operation.user;
                            let dossier = operation.dossier;

                            let action = operation.action;
                            let nom = self.formatString((user.prenom ? ' ' + user.prenom : '') + "  " +  (user.nom).toUpperCase()) + " ( "
                                +dossier.numero_dossier + " )";
                            let element = self.formatString(operation.operationable_type);
                            let fileSlug = dossier.slug;
                            oArray.push({nom: nom, element: element, action: action, fileSlug:fileSlug});
                        }
                    }
                });

                return oArray;
            },

            mOperations:function(){
                let oArray = [];
                let self = this;
                _.forEach(this.operations, function(operation) {

                    if(typeof operation.user == "object"){
                        if (operation.hasOwnProperty('dossier')){
                            let user = operation.user;
                            let dossier = operation.dossier;
                            let o = {};

                            o.id = operation.id;
                            o.action = operation.action;
                            o.slug = user.slug;
                            o.onom = self.formatString((user.prenom ? ' ' + user.prenom : '') + "  " +  (user.nom).toUpperCase()) + " ( "
                                +dossier.numero_dossier + " )";
                            o.oslug = user.slug;
                            o.element = self.formatString(operation.operationable_type);
                            o.oFileSlug = dossier.slug;
                            oArray.push(o);
                        }

                    }

                });

                return oArray;
            },

            rows: function() {
                return this.mInstitutions.length;
            },

            operationRows: function() {
                return this.mOperations.length;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            

            hasSelectInstitution:function () {
                return _.isNull(this.selectedInstitution) || _.isEmpty(this.selectedInstitution);
            },

            patientPeInstitutionsRows:function () {
                let iArray = [];
                let institutions = [];
                if(!_.isNull(this.selectedInstitution) && !_.isEmpty(this.selectedInstitution)) {
                    institutions = this.selectedInstitution;
                }
                else{
                    institutions = this.institutions;
                }
                // console.log('institut');
                // console.log(this.institutions);
                _.forEach(institutions, function(institution) {
                    if(typeof institution.patients == "object"){
                        let pArray = [];
                        _.forEach(institution.patients, function(patient) {
                            if(!_.isNull(patient.dossier) && !_.isNull(patient.user)){
                                let prenom = patient.user.prenom ? patient.user.prenom : '';
                                prenom =  prenom.toLowerCase();

                                let infoPatient = (patient.user.nom).toUpperCase() +" "+ (prenom.charAt(0)).toUpperCase() + prenom.substring(1)+ " ( "
                                    +patient.dossier.numero_dossier + " )";
                                pArray.push({institution:institution.name, infoPatient:infoPatient, fileSlug:patient.dossier.slug, institutionSlug:institution.slug});
                            }
                        });

                        iArray.push({mode: "span", label: institution.name, html:false,
                            children: pArray
                        });
                    }

                });
                // }

                return iArray;
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
                
				if (value) {
                    // console.log("on entre ici?");
                    // await this.getSearchPatient(value);
                    // console.log(this.patients);
                    // this.currentPatientArray=this.patients;
                    // this.currentPatientArrayFiltered = this.currentPatientArray;
                    if(value.length==1){
                        const newCurrentPatientArray=this.currentPatientArray;
                        // console.log("et après?");
                        // console.log(newCurrentPatientArray);

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

					    this.paginationObject = pagination(newCurrentPatientArray);
                        // console.log("pagination");
                        // console.log(this.paginationObject!==null);
                        // console.log(this.paginationObject.numOfPages);
                    }
                    
                    if(value.length>1){
                        // console.log("ou bien?")
                        const newCurrentPatientArray = this.currentPatientArray.filter(app => {
                            let result = false;

                            if (app.nom) {
                                result = result || app.nom.toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.dossier) {
                                result = result || app.dossier.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.age) {
                                result = result || app.age.toString().toLowerCase().includes(value.toLowerCase());
                            }

                            if (app.email) {
                                result = result || app.email.toLowerCase().includes(value.toLowerCase());
                            }

                            return result;
                        });

                        this.currentPatientArrayFiltered = newCurrentPatientArray;

                        this.paginationObject = pagination(newCurrentPatientArray);
                        // console.log("pagination");
                        // console.log(this.paginationObject!==null);
                        // console.log(this.paginationObject.numOfPages);
                    }
					
					
				} else {
					this.currentPatientArrayFiltered = this.currentPatientArray;
					this.paginationObject = pagination(this.currentPatientArray);
				}
                this.filteredValue=this.paginationObject;
                // this.filteredValue(null,this.paginationObject);
			},

			handleSort(value, sortDirection = 'asc') {
                
				if (value) {
					let newCurrentPatientArray = [];
					const sortType = ['nom', 'dossier', 'age', 'email'];
					const restOfType = sortType.filter(i => i !== value);

					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentPatientArray = _.orderBy(this.currentPatientArrayFiltered, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);

					this.paginationObject = pagination(newCurrentPatientArray);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			typeFilter(value, ) {
                
                // console.log(value)
                      if (this.filteredValue == 2){
                            //Non archivés
                            value = _.filter(value,function (medecine) {
                            return _.isNull(medecine.archievedAt);
                            })
                        }else if (this.filteredValue == 3){
                            //Non transmis
                            value = _.filter(value,function (medecine) {
                            return _.isNull(medecine.passedAt);
                            })
                        }else if (this.filteredValue ==4){
                            //Archivés
                            value = _.filter(value,function (medecine) {
                            return !_.isNull(medecine.archievedAt);
                            })
                        }else if (this.filteredValue == 5){
                            //Transmis
                            value = _.filter(value,function (medecine) {
                            return !_.isNull(medecine.passedAt);
                            })
                        }
				if (value) {
					this.paginationObject = pagination(value);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			onEtablissementClick(etablissementId){
                let etablissement = _.filter(this.institutions,function (institution) {
                    return institution.id == etablissementId;
                });
                this.$store.dispatch('setselectedInstitution', { selectedInstitution : etablissement });
            },

            onOperationClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },

            onPatientPerInstCellClick(params){
                // if (params.column.field == "institution")
                //     this.$router.push({ name: 'institution', params: { institution: params.row.institutionSlug } });
                // else
                let isPraticienPatient=_.find(this.mUserInstitutions,function (institution) {

                    let patient = _.find(institution.patients, function (patient) {
                        return  patient.user_id == params.row.id;
                    });
                    if(_.isUndefined(patient))
                        return patient;
                    return institution;
                });

                if (_.isUndefined(isPraticienPatient)){
                    Swal.fire({
                        title: 'Êtes vous sûr ?',
                        text: "Ce patient n'appartient pas à l'un de vos établissements. Vous serez fichié dans le système si vous y accédez",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#00ada7',
                        cancelButtonColor: '#f5365c',
                        confirmButtonText: 'Oui, accéder!'
                    }).then((result) => {
                        if (result.value) {
                            // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                            this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                        }
                    })
                }else{
                    // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                    this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                }
            },

            notEmpty(item){
                return item.length > 0;
            },

            loadForm() {
                // console.log("on est ici d'abord?");
                // console.log(this.shouldDisplay);
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = [...this.mPatients];
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

            getInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getInstitutions', { args : args });
            },

            async getSearchPatient(value) {
                // console.log("juste pour vérifier");
                let args = {
                    patient: value
                };

                await this.$store.dispatch("getSearchPatient", {
                    args : args
                });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },
            getDoctors() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getControlDoctors', {
                args: args
            });
        },



            // getPatients() {
            //     let args = {
            //         offset: this.offset,
            //         limit: this.limit
            //     };
            //
            //     this.$store.dispatch('getPatients', { args : args });
            // },

            getLatestOperation() {
                let args = {

                };

                this.$store.dispatch('getOperations', { args : args });
            },


            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                // this.$router.push({ name: 'patient', params: { patient: item.selectedObject.slug } });
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: item.selectedObject.fileSlug } })).href +  '#generale');
                // this.$router.push({ name: 'medical-file', params: { file: item.selectedObject.fileSlug } });
            },

            formatString(item){
                return item.length > 36 ? item.substr(0, 36) + '...' : item;
            },

        },

        mounted() {
            this.loadForm();
            this.getDoctors();
            // Fetch patient list
            // this.getPatients();

            // Fetch institution list
            // this.getInstitutions();

            // Fetch user institution list
            // this.getUserInstitutions();

            // Fetch institution list
            // this.getLatestOperation();

        }
    }
</script>

<style scoped>
</style>
